import { render } from "./DashboardView.vue?vue&type=template&id=4d3e4b5d&ts=true"
import script from "./DashboardView.vue?vue&type=script&lang=ts"
export * from "./DashboardView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__